import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const manageAudienceNRO: NavigationRoutingObject = {
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("manage-audience-sidebar-pill-menu-option", "Manage Audience"),
  pageNameForTracking: () => "Manage Audience",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("manage-audience-description-nav", "Take actions to manage the health of your userbase"),
  icon: "nav-system-manage-audience",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("bulk_user_merge_preview");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("manage-audience-alt-keyword-1", "merge users"),
        t("manage-audience-alt-keyword-2", "duplicate"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
